import { useSession } from '@/features/auth/session-context';
import { QUESTION_PERMISSIONS } from './types';

/**
 * What the active role may do with questions from the app (RL-991): the
 * doctor reads and replies / closes (`doctor_inbox:read` / `:manage`), the
 * manager oversees and routes (`doctor_inbox:oversee`). Whether the text is
 * shown is the API's `textShown`, not this.
 */
export function useQuestionAccess() {
  const { hasPermission } = useSession();
  const read = hasPermission(QUESTION_PERMISSIONS.read);
  const oversee = hasPermission(QUESTION_PERMISSIONS.oversee);
  return {
    canView: read || oversee,
    canReadInbox: read,
    canAnswer: hasPermission(QUESTION_PERMISSIONS.manage),
    canRoute: oversee,
  };
}
